export const PHOTOGRAPHERS_CATEGORY_ID = "647d5787-4fb6-499a-b5a1-4356b438c89a";
const PHOTOGRAPHER_TITLES = new Set([
  "резервирање на фотограф и видеограф",
  "book a photographer and videographer",
]);

const calendarDay = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) return null;
  const timestamp = Date.parse(`${value}T00:00:00Z`);
  if (!Number.isFinite(timestamp) || new Date(timestamp).toISOString().slice(0, 10) !== value) return null;
  return timestamp / 86400000;
};

export function buildNextTasks({ payments = [], guests = [], todos = [] }, now = new Date()) {
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) / 86400000;
  const tasks = [];
  const due = payments.filter((payment) => {
    const day = calendarDay(payment.due_date);
    return ["planned", "partially_paid"].includes(payment.status) &&
      Number(payment.amount_due) > Number(payment.amount_paid) &&
      day !== null && day <= today + 6;
  }).sort((a, b) => a.due_date.localeCompare(b.due_date) || String(a.id).localeCompare(String(b.id)))[0];

  if (due) tasks.push({
    id: "payment", destination: "payments",
    title: `${calendarDay(due.due_date) < today ? "Задоцнето плаќање" : "Плаќање во следните 7 дена"}: ${due.title}`,
    action: "Отвори плаќања",
  });

  const uniqueGuests = new Map(guests.flat().filter(Boolean).map((guest) => [guest.id, guest]));
  const unseated = [...uniqueGuests.values()].filter((guest) =>
    guest.RSVP_status !== "REJECTED" && !guest.seated && guest.table_id == null
  ).length;
  if (unseated) tasks.push({
    id: "seating", destination: "tables",
    title: unseated === 1 ? "1 гостин сè уште нема место" : `${unseated} гости сè уште немаат место`,
    action: "Распореди гости",
  });

  const photographerTodos = todos.filter((todo) => PHOTOGRAPHER_TITLES.has(String(todo.title || "").trim().toLowerCase()));
  if (photographerTodos.length && !photographerTodos.some((todo) => todo.checked)) tasks.push({
    id: "photographer", destination: "photographers",
    title: "Изборот на фотограф сè уште не е означен како завршен",
    action: "Разгледај фотографи",
  });
  return tasks.slice(0, 3);
}
